import { isFiniteNumber } from '../lib/number';

/** Manually configured PSD references. Values are stored in base length units (metres). */
export interface PsdControlLine {
    percent: number;
    value: number;
}

export const supportedPsdControlLinePercents = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100] as const;
const supportedPsdControlLinePercentSet = new Set<number>(supportedPsdControlLinePercents);

export function parsePsdControlLines(serialized: unknown): PsdControlLine[] {
    
    if (serialized === '' || serialized == null)
        return [];

    if (typeof serialized !== 'string')
        throw new Error('Control lines must be JSON text.');

    const entries: unknown = JSON.parse(serialized);
    
    if (!Array.isArray(entries) || entries.length > supportedPsdControlLinePercents.length)
        throw new Error('Invalid control lines.');
    
    const seen = new Set<number>();
    return entries.map(entry => {
        if (!entry || !supportedPsdControlLinePercentSet.has(entry.percent) ||
            !isFiniteNumber(entry.value) || entry.value <= 0 || seen.has(entry.percent)) {
            throw new Error('Each D-value must be unique (D10–D100 in increments of 10) with a positive, finite control value.');
        }
        seen.add(entry.percent);
        return { percent: entry.percent, value: entry.value };
    });
}
